module.exports = __webpack_public_path__ + "img/vignettes-asso_0002_oeil-des-cariatides.21177728.jpg";